import { Box } from "@mui/material";

const FlexWrapper = (props: any) => {
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      borderRadius={5}
      {...props}
    >
      {props.children}
    </Box>
  );
};

export default FlexWrapper;
